import React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { LayoutGrid, PlusCircle, Settings, LogOut, MapPinned, Shield, Package, Search, GitCompareArrows, Brain, ClipboardCheck } from 'lucide-react';

export default function Layout() {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const nav = [
    { to: '/', label: 'Análisis', icon: LayoutGrid, testid: 'nav-analyses' },
    { to: '/search', label: 'Buscador (Etapa 2)', icon: Search, testid: 'nav-search' },
    { to: '/compare', label: 'Comparador multi-punto', icon: GitCompareArrows, testid: 'nav-compare' },
    { to: '/predict', label: 'Predictor de ventas', icon: Brain, testid: 'nav-predict' },
    { to: '/field', label: 'Checklist de campo', icon: ClipboardCheck, testid: 'nav-field' },
    { to: '/analyses/new', label: 'Nuevo análisis', icon: PlusCircle, testid: 'nav-new-analysis' },
    { to: '/profiles', label: 'Perfiles', icon: Package, testid: 'nav-profiles' },
  ];
  if (user?.role === 'admin') nav.push({ to: '/admin', label: 'Administración', icon: Shield, testid: 'nav-admin' });

  return (
    <div className="min-h-screen bg-slate-50 flex">
      <aside className="w-64 border-r border-slate-200 bg-white flex flex-col">
        <div className="px-6 py-6 border-b border-slate-200">
          <div className="flex items-center gap-2">
            <MapPinned size={20} className="text-blue-900" strokeWidth={2} />
            <div className="font-display font-extrabold text-lg tracking-tight text-slate-900">StrategIA</div>
          </div>
          <div className="label-caps mt-1">Location Intelligence</div>
        </div>
        <nav className="flex-1 py-4">
          {nav.map((n) => {
            const active = loc.pathname === n.to || (n.to !== '/' && loc.pathname.startsWith(n.to));
            const Icon = n.icon;
            return (
              <Link
                key={n.to}
                to={n.to}
                data-testid={n.testid}
                className={`flex items-center gap-3 px-6 py-2.5 text-sm transition-transform duration-200 hover:-translate-y-[1px] ${
                  active ? 'bg-blue-900 text-white font-semibold' : 'text-slate-700 hover:bg-slate-100'
                }`}
              >
                <Icon size={16} strokeWidth={2} />
                {n.label}
              </Link>
            );
          })}
        </nav>
        <div className="border-t border-slate-200 p-4">
          <div className="text-xs text-slate-500 mb-2" data-testid="user-email">{user?.email}</div>
          <div className="text-xs text-slate-400 mb-3 uppercase tracking-widest font-semibold">{user?.role === 'admin' ? 'Administrador' : 'Analista'}</div>
          <button
            data-testid="btn-logout"
            onClick={logout}
            className="flex items-center gap-2 text-xs text-slate-600 hover:text-red-700 transition-colors"
          >
            <LogOut size={14} /> Cerrar sesión
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
